import Core from "@/modules/core/service/Core";

const url = "/api/disposition/order/ics?technician={0}&delta={1}"

export default {
    download ( technician, delta) {
        return Core.download.perform(url.replace("{0}", technician).replace("{1}", delta? "true" : "false"));
    }
}